import { useContext, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-circular-progressbar/dist/styles.css";

import Practice from "../../components/SPanel/Practice";
import { renderHomeWidget } from "../../components/SPanel/Home/HomeWidgets";
import useStudentHomeData from "../../components/SPanel/Home/useStudentHomeData";
import { SIZES } from "../../components/SPanel/Home/homeLayout";
import { UserContext } from "../../UserContext";

// Testare: ca la calendar — fără panouri, 12px de la margini, sus rândul comun (.pageToolbar).
// Sub bilete, Statistica: widget-urile de testare de pe pagina principală (aceleași date, aceleași
// carduri). În timpul testului nu se vede.
const TEST_WIDGETS = [
   { id: "accuracy", size: "2x1" },
   { id: "practice", size: "2x1" },
   { id: "progress", size: "2x1" },
   { id: "activity", size: "2x1" },
];

function TestStats() {
   const { user } = useContext(UserContext);
   const { practice, activity } = useStudentHomeData();
   const data = { user, practice, activity };
   return (
      <section className="shome sTest__stats" aria-labelledby="sTest-stats-title">
         <h2 id="sTest-stats-title" className="sTest__statsTitle">
            Statistică
         </h2>
         <div className="hgrid sTest__widgets">
            {TEST_WIDGETS.map((item, index) => {
               const size = SIZES[item.size];
               return (
                  <div
                     key={item.id}
                     className={`hw hw--${item.size}`}
                     style={{ gridColumn: `span ${size.w}`, gridRow: `span ${size.h}`, "--i": index }}
                  >
                     <div className="hw__jiggle">{renderHomeWidget(item, data)}</div>
                  </div>
               );
            })}
         </div>
      </section>
   );
}

function SPTest() {
   const [view, setView] = useState("tickets");
   return (
      <main className="main">
         <section className="page-wrapper sTest">
            <Practice onViewChange={setView} />
            {view === "test" ? null : <TestStats />}
         </section>
      </main>
   );
}

export default SPTest;
